import React, { useState, useEffect, createContext } from 'react';
import moment from 'moment';
import Header from '../../common/components/Header/Header';
import Sidebar from '../../common/components/Sidebar/Sidebar';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../data/SiteConfig';
import TimeFilterWrapper from '../../components/TimeFilterWrapper/TimeFilterWrapper';
import Table from '../../components/Table/RsponsiveTable';
import Columns from '../../components/Table/CallDetailsColumn';
import { getCallDetails } from '../../common/constants/api';
import { faMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons';
import CallSummary from './CallSummary';
import AutoCompleteFilterBar from '../../common/components/AutoCompleteFilterBar/AutoCompleteFilterBar';

import CommonSelect from '../../components/Dashboard-res/CommonComponent/CommonSelect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const StatusOPtion = [];

let fromDate;
let toDate;
export const FromDateRange = () => {
  return fromDate;
};
export const toDateRange = () => {
  return toDate;
};
export const StateExporterCallDetails = createContext();

const CallDetails = () => {
  const [TableData, setTableData] = useState([]);
  const [TableMasterData, setMasterTableData] = useState([]);
  const [tableInfo, setTableInfo] = useState({ size: 200 });
  const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
  const [tableLoading, setTableLoading] = useState(false);
  const [rmId, setRmId] = useState('');
  const [callsBy, setCalls] = useState({ value: 'direct', label: 'Direct' });
  const [column, setColumn] = useState('total');
  const [direction, setDirection] = useState('desc');
  useEffect(() => {
    setTableLoading(true);
    fromDate = startDate;
    toDate = endDate;

    getCallDetails(
      0,
      200,
      startDate,
      endDate,
      'total',
      'desc',
      rmId,
      callsBy.value
    )
      .then(data => {
        setTableData(data.data);
        setTableInfo(data.dataPage);
        setMasterTableData(data.data);
        setTableLoading(false);
      })
      .catch(err => {
        setTableData([]);
      });
  }, [startDate, endDate, rmId, callsBy.value]);

  let ListData = [];
  const SearchAndUpdate = value => {
    let filteredFiled = TableMasterData.filter(each => {
      return (
        each.firstName
          .toString()
          .toLowerCase()
          .includes(value.toString().toLowerCase()) ||
        each.lastName
          .toString()
          .toLowerCase()
          .includes(value.toString().toLowerCase())
      );
    });
    setTableData(filteredFiled);
  };

  const handleSort = (column, sortDirection) => {
    getCallDetails(
      0,
      200,
      startDate,
      endDate,
      column.selector,
      sortDirection,
      rmId,
      callsBy.value
    ).then(data => {
      setTableData(data.data);
      setTableInfo(data.dataPage);
      setMasterTableData(data.data);
      setColumn(column.selector);
      setDirection(sortDirection);
    });
  };
  const handlePage = page => {
    getCallDetails(
      parseInt(page) - 1,
      200,
      startDate,
      endDate,
      column,
      direction,
      rmId,
      callsBy.value ? callsBy.value : 'direct'
    ).then(data => {
      setTableData(data.data);
      setTableInfo(data.dataPage);
      setMasterTableData(data.data);
    });
  };
  const handleRowPerPage = (perPage, page) => {
    getCallDetails(
      parseInt(page) - 1,
      perPage,
      startDate,
      endDate,
      column,
      direction,
      rmId,
      callsBy.value
    ).then(data => {
      setTableData(data.data);
      setTableInfo(data.dataPage);
      setMasterTableData(data.data);
    });
  };
  const CustomPagintion = () => {
    alert('');
  };
  return (
    <React.Fragment>
      <Helmet title={`Call Details | ${siteTitle}`} />
      <div className="bg-grey-950 relative min-h-screen overflow-auto font-roboto text-sm font-normal m-0 p-0">
        <div className="min-h-screen flex pt-17 md:pt-0 ">
          <Sidebar />
          <div className="widhtMd max-screen flex-1 w-full ">
            <Header />
            <div className="flex flex-row flex-wrap justify-between mt-2 ml-6">
              <StateExporterCallDetails.Provider
                value={{
                  startDate,
                  setStartDate,
                  endDate,
                  setEndDate,
                  CallDetails: true
                }}
              >
                <TimeFilterWrapper lastMonth />
              </StateExporterCallDetails.Provider>
            </div>

            <div className="mb-10">
              <Table
                rm
                rmId={rmId}
                setRmId={setRmId}
                StatusFilter=""
                Search=""
                data={TableData ? TableData : []}
                StatusOPtion={StatusOPtion ? StatusOPtion : []}
                columns={Columns}
                TableInfo={tableInfo}
                startDate={startDate}
                endDate={endDate}
                serverPagination
                serverPaginationUrl={getCallDetails}
                filterImage={faMapMarkerAlt}
                serchBarPlaceHolder="Search Relationship Manager"
                GetLeadStatus={ListData}
                tableLoading={tableLoading}
                tableListbelongs="Call Details"
                filterComponent={false}
                customeFilter
                customeFilterFunction={() => true}
                searchComponent={false}
                serverSort
                CustomhandleSort={handleSort}
                CustomhandlePageChange={handlePage}
                CustomhandlePerRowsChange={handleRowPerPage}
                onSerachChange={SearchAndUpdate}
                customHeaderComponent={() => {
                  return (
                    <div className="flex  flex-row flex-wrap  justify-between  w-full  h-full   lg:py-0 items-center ">
                      <div className="mx-2 my-2">
                        <AutoCompleteFilterBar setRmId={setRmId} />
                      </div>
                      <div className="lg:w-3/12 right-0 w-8/12 mx-2 flex flex-row ">
                        <CommonSelect sort={true}
                          name="callsBy"
                          value={callsBy}
                          onChange={e => {
                            setCalls({ value: e.value, label: e.label });
                          }}
                          onBlur={() => {}}
                          options={[
                            {
                              label: 'All',
                              value: 'all'
                            },

                            {
                              label: 'Direct',
                              value: 'direct'
                            },

                            {
                              label: 'BP',
                              value: 'bp'
                            }
                          ]}
                          stylesContainer={{
                            height: '40px',
                            marginBottom: '0px',
                            fontSize: '40px',
                            paddingRight: '20px'
                          }}
                          dropdownStyle={{
                            top: '40px',
                            fontSize: '16px',
                            backgroundColor: '#fff',
                            paddingRight: '2px',
                            alignItems: 'center',
                            fontFamily: 'Roboto',
                            fontWeight: 400
                          }}
                          styleText={{
                            fontSize: '16px',
                            padding: '4.5px 4px 4.5px 16px',
                            color: '#8D8D8D',
                            fontFamily: 'Roboto'
                          }}
                        />
                      </div>
                    </div>
                  );
                }}
                paginationComponent={CustomPagintion}
                rows="200"
              />

              {TableData.length > 0 ? (
                <CallSummary
                  startDate={startDate}
                  endDate={endDate}
                  rmId={rmId}
                  setRmId={setRmId}
                  callsBy={callsBy.value}
                  setCalls={setCalls}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default CallDetails;
